import React from "react";
import { InnerWrapper } from "../wrapper/wrapper";
import { HeroBackground, HeroText } from "./hero.components";

function HeroSection({ heroBgImage, text }) {
  return (
    <HeroBackground sx={{ backgroundImage: `url(${heroBgImage})` }}>
      <InnerWrapper sx={{ position: "relative" }}>
        <HeroText>{text}</HeroText>
      </InnerWrapper>
    </HeroBackground>
  );
}

export default HeroSection;
